var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterviewTracker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7083 0.5C13.974 0.5 15 1.52601 15 2.79167V13.2083C15 14.474 13.974 15.5 12.7083 15.5H2.29167C1.02601 15.5 0 14.474 0 13.2083V2.79167C0 1.52601 1.02601 0.5 2.29167 0.5H12.7083ZM12.7083 1.75H2.29167C1.71637 1.75 1.25 2.21637 1.25 2.79167V13.2083C1.25 13.7836 1.71637 14.25 2.29167 14.25H12.7083C13.2836 14.25 13.75 13.7836 13.75 13.2083V2.79167C13.75 2.21637 13.2836 1.75 12.7083 1.75ZM3.95833 5.50276C4.27475 5.50276 4.53624 5.73687 4.57763 6.04063L4.58333 6.12507V11.5471C4.58333 11.8908 4.30351 12.1694 3.95833 12.1694C3.64192 12.1694 3.38042 11.9353 3.33904 11.6316L3.33333 11.5471V6.12507C3.33333 5.78138 3.61316 5.50276 3.95833 5.50276ZM11.0417 3.83609C11.3581 3.83609 11.6196 4.06476 11.661 4.36145L11.6667 4.44393V11.5616C11.6667 11.8973 11.3868 12.1694 11.0417 12.1694C10.7253 12.1694 10.4638 11.9408 10.4224 11.6441L10.4167 11.5616V4.44393C10.4167 4.10823 10.6965 3.83609 11.0417 3.83609ZM7.47925 8C7.7882 7.99703 8.04579 8.22223 8.08914 8.51726L8.09553 8.59933L8.12497 11.5554C8.1283 11.8897 7.85778 12.1634 7.52075 12.1667C7.2118 12.1697 6.95421 11.9445 6.91086 11.6495L6.90447 11.5674L6.87503 8.61129C6.8717 8.27702 7.14222 8.00336 7.47925 8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterviewTracker);
export default __webpack_public_path__ + "static/media/interview-tracker.56a100dbe4b31c16c53b2d48e97a15b5.svg";
export { ForwardRef as ReactComponent };